import React from 'react';
import DragHandle, {
  HANDLE_POSITIONS
} from '../../../components/wysiwyg_editor/page_content_items/DragHandle';
import {
  INNER_HANDLE_HEIGHT as HANDLE_HEIGHT,
  INNER_HANDLE_WIDTH as HANDLE_WIDTH
} from '../../../utils/wysiwyg_editor/contentItemHandleLocations';

import icon from '@images/wysiwyg_editor/move_element.svg';
import type { TSprungOverlayLocations } from '../../../utils/wysiwyg_editor/contentItemHandleLocations';
import { SpringValue } from '@react-spring/web';

type TProps = {
  cursor: string;
  forceCursor: boolean;
  location: TSprungOverlayLocations;
  pageItemId: string;
  zIndex: number;
  onDrag: (e: Event) => void;
  onDragStart: () => void;
  onDragStop: () => void;
};

function InnerDragHandle(props: TProps): React.ReactElement {
  return (
    <DragHandle
      forceCursor={props.forceCursor}
      top={props.location.y}
      left={props.location.x}
      height={props.location.height}
      width={props.location.width}
      paddedTop={props.location.handlePaddedInnerY}
      paddedLeft={props.location.handlePaddedInnerX}
      paddedHeight={props.location.handlePaddedInnerHeight}
      paddedWidth={props.location.handlePaddedInnerWidth}
      pageItemId={props.pageItemId}
      position={HANDLE_POSITIONS.inner}
      onDrag={props.onDrag}
      onDragStart={props.onDragStart}
      onDragStop={props.onDragStop}
    >
      <div
        style={{
          background: `url(${icon}) top left`,
          backgroundSize: `${HANDLE_HEIGHT}px ${HANDLE_HEIGHT}px`,
          cursor: props.cursor || 'default',
          position: 'absolute',
          height: HANDLE_HEIGHT,
          width: HANDLE_WIDTH,
          zIndex: props.zIndex
        }}
      />
    </DragHandle>
  );
}

export default InnerDragHandle;
